import React, { FC } from 'react';
import { Stack } from '@mui/material';

import { Header } from './Header';
import { DishIngredients } from './DishIngredients';
import { EquipmentSection } from './EquipmentSection';
import { TagsSection } from './TagsSection';
import { InstructionsSection } from './InstructionsSection';
import { NutritionalSection } from './NutritionalSection';
import { DishData, MealKitData } from './types';

interface ContentSectionsProps {
  data: DishData | MealKitData;
  isMealKit: boolean;
  selectedVariantId: string;
  onVariantChange: (variantId: string) => void;
  showVariantError: boolean;
  isPreviewMode: boolean;
  v2?: boolean;
}

export const ContentSections: FC<ContentSectionsProps> = ({
  data,
  isMealKit,
  selectedVariantId,
  onVariantChange,
  showVariantError,
  isPreviewMode,
  v2,
}) => {
  const mealKitData = isMealKit ? (data as MealKitData) : null;

  return (
    <Stack spacing={2}>
      <Header
        title={data.name}
        description={data.description}
        tags={data.tags?.filter((tag) => tag.isPinned)}
      />

      <DishIngredients
        isMealKit={isMealKit}
        simpleIngredients={
          !isMealKit ? (data as DishData).ingredients : undefined
        }
        mealKitIngredients={mealKitData?.ingredients}
        variants={mealKitData?.variants}
        selectedVariantId={selectedVariantId}
        onVariantChange={onVariantChange}
        showVariantError={showVariantError}
        isReadOnly={isPreviewMode}
        photoUrl={data.photoUrl}
        name={data.name}
      />

      {isMealKit && mealKitData?.equipment && (
        <EquipmentSection equipment={mealKitData.equipment} />
      )}

      <TagsSection tags={data?.tags} v2={v2} />

      <InstructionsSection instructions={data.instructions} />

      <NutritionalSection
        isMealKit={isMealKit}
        nutritionalValuesUrl={
          !isMealKit ? (data as DishData).nutritionalValuesUrl : undefined
        }
        nutritionalValues={mealKitData?.nutritionalValues}
      />
    </Stack>
  );
};

export default ContentSections;
